var map = {
	"./de_json_menu.json": "./public/app/jsonMenu/de_json_menu.json",
	"./es_json_menu.json": "./public/app/jsonMenu/es_json_menu.json",
	"./fr_json_menu.json": "./public/app/jsonMenu/fr_json_menu.json",
	"./nl_json_menu.json": "./public/app/jsonMenu/nl_json_menu.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/app/jsonMenu sync recursive ^\\.\\/.*_json_menu\\.json$";